import { GeocodingHelpButton } from "@/features/geocoders";
import { UnmatchedType } from "@/tools/risk-bands/batch";
import ReloadOutlined from "@ant-design/icons/es/icons/ReloadOutlined";
import { Button, Collapse, List, Row } from "antd";
import Markdown, { Components } from "react-markdown";
export interface UnmatchedAddressesCollapseProps {
  addresses: UnmatchedType[];
  onRetry?: () => void;
}
const geocodingHelpComponent: Components = {
  a: props => {
    return <GeocodingHelpButton isLink>{props.children}</GeocodingHelpButton>;
  }
};
export const UnmatchedAddressesCollapse = ({
  addresses,
  onRetry
}: UnmatchedAddressesCollapseProps) => {
  const title = addresses.length === 1 ? "1 unmatched address" : `${addresses.length} unmatched addresses`;
  return <Collapse size="small" className="[&_.ant-collapse-header]:!items-center" items={[{
    key: "primary",
    label: `${title}. Click to view.`,
    extra: <Row align="middle" justify="end" className="gap-1">
              <GeocodingHelpButton>Geocoding Help</GeocodingHelpButton>
              {onRetry && <div className="flex gap-2">
                  <Button type="default" onClick={onRetry} icon={<ReloadOutlined />}>
                    Retry
                  </Button>
                </div>}
            </Row>,
    children: <List itemLayout="horizontal" dataSource={addresses} size="small" renderItem={(item, i) => <List.Item>
                  <List.Item.Meta title={`${i + 1}. ${item.address}`} description={<Markdown components={geocodingHelpComponent}>{item.error}</Markdown>} />
                </List.Item>} />
  }]} data-sentry-element="Collapse" data-sentry-component="UnmatchedAddressesCollapse" data-sentry-source-file="UnmatchedAddressesCollapse.tsx"></Collapse>;
};